export const DETACHED_HOUSE = 'Detached house';
export const APARTMENT_HOUSE = 'Apartment house';

export default Object.freeze({
  DETACHED_HOUSE,
  APARTMENT_HOUSE
});
